 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"1a48c3c1","2":"1bfc9850","3":"6728d85a","4":"d7eeaac4","5":"5e2a4920","6":"0c428ae2","7":"c01d2b654a2cd98f61aed0fb6aaae15162621cb9","8":"6e80d0d2de6739af37654523b6e771f055c0fe1d","9":"976a297d18415909ef9be9be62e761503534f578","11":"545f34e4","13":"b98bc7c3","14":"component---src-pages-404-js","15":"component---src-pages-about-this-website-jsx","16":"component---src-pages-apelle-jsx","17":"component---src-pages-approach-commitment-jsx","18":"component---src-pages-approach-fiber-jsx","19":"component---src-pages-approach-jsx","20":"component---src-pages-approach-walnut-html-jsx","21":"component---src-pages-cm-youtube-jsx","22":"component---src-pages-deli-jsx","23":"component---src-pages-hitokuchido-jsx","24":"component---src-pages-index-js","25":"component---src-pages-inquiry-faq-page-jsx","26":"component---src-pages-inquiry-jsx","27":"component---src-pages-naturel-bread-jsx","28":"component---src-pages-naturel-jsx","29":"component---src-pages-privacy-policy-jsx","30":"component---src-pages-product-search-jsx","31":"component---src-pages-qa-on-raw-materials-and-additives-jsx","32":"component---src-pages-recipe-book-jsx","33":"component---src-pages-slowbread-jsx","34":"component---src-pages-sweets-sweets-jsx","35":"component---src-pages-thismonth-products-jsx","36":"component---src-pages-variety-bread-jsx","37":"component---src-pages-we-jsx","38":"component---src-templates-product-template-jsx","39":"d0447323","40":"d64684d8","43":"styles"}[chunkId]||chunkId) + "-" + {"0":"13a7d6b3a7907cbc1448","1":"cd9f513733e93c31580b","2":"a8068c7eaa890cd3a0a1","3":"1e99f187b1eb89545a24","4":"5d70dcfb7a4e6e14f033","5":"f38cbf1ec9ac2dc4e278","6":"00641d6de8442e5813c5","7":"9dd4a944e7cf19b905d4","8":"2b87d5bc66c6ad457b15","9":"7f189fb60588e7ceec30","11":"a3b6bd3e9c01ac6cf0c6","13":"f61d31925f8eb8cb8e36","14":"cafd977a5f6e4e76743b","15":"8a2aeb7a341aeebb2812","16":"dbc0fbb1bdf9ac1cde4e","17":"a226aa27e2cb36c449b6","18":"f876fd7f2863f88f496f","19":"cec44eaf7930bc5fdb38","20":"4a6f59538f0a7bd8c7e9","21":"cd363e146707e9e73251","22":"d8e04d2af8c677173d48","23":"e7811ae7391605811b87","24":"049d8a17894bb47f7bad","25":"251e4d9b68545a89fa27","26":"7dd7002ddf9e6279dd4f","27":"6b378cead916818753c2","28":"16e48892bff9ee57d294","29":"43818f3b5fc9573fb7de","30":"c69583a7374610fbe233","31":"00f6153814ace9aa9cc3","32":"c3f7310af57284a4546c","33":"3b804f4ada43b75733eb","34":"0a75f31a1115b8dd033e","35":"374c7a88ad8d282ef603","36":"d77b763e144c04154779","37":"5b3339f2d756e74de66b","38":"f25a4809a387509a70ed","39":"89e62089eb867c907854","40":"59080e3976ad4bc892ed","43":"a11f04401e7634b38c60"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"43":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"1a48c3c1","2":"1bfc9850","3":"6728d85a","4":"d7eeaac4","5":"5e2a4920","6":"0c428ae2","7":"c01d2b654a2cd98f61aed0fb6aaae15162621cb9","8":"6e80d0d2de6739af37654523b6e771f055c0fe1d","9":"976a297d18415909ef9be9be62e761503534f578","11":"545f34e4","13":"b98bc7c3","14":"component---src-pages-404-js","15":"component---src-pages-about-this-website-jsx","16":"component---src-pages-apelle-jsx","17":"component---src-pages-approach-commitment-jsx","18":"component---src-pages-approach-fiber-jsx","19":"component---src-pages-approach-jsx","20":"component---src-pages-approach-walnut-html-jsx","21":"component---src-pages-cm-youtube-jsx","22":"component---src-pages-deli-jsx","23":"component---src-pages-hitokuchido-jsx","24":"component---src-pages-index-js","25":"component---src-pages-inquiry-faq-page-jsx","26":"component---src-pages-inquiry-jsx","27":"component---src-pages-naturel-bread-jsx","28":"component---src-pages-naturel-jsx","29":"component---src-pages-privacy-policy-jsx","30":"component---src-pages-product-search-jsx","31":"component---src-pages-qa-on-raw-materials-and-additives-jsx","32":"component---src-pages-recipe-book-jsx","33":"component---src-pages-slowbread-jsx","34":"component---src-pages-sweets-sweets-jsx","35":"component---src-pages-thismonth-products-jsx","36":"component---src-pages-variety-bread-jsx","37":"component---src-pages-we-jsx","38":"component---src-templates-product-template-jsx","39":"d0447323","40":"d64684d8","43":"styles"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","43":"1e3169ebbb0d083d6bb3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
